import React, { useState } from "react";
import { Modal, Input, Switch, Button, message, Radio } from "antd";
import { _isNullorEmpty, dateFormat } from "../../../utils/index";
import BoxServe from "../../../ajax/api/index";
const { TextArea } = Input;

export default function Shell(props) {
  const [command, setCommand] = useState(""); // 命令输入框

  const [timeOut, setTimeOut] = useState(120); // 任务超时时间(秒)

  const [autoClose, setAutoClose] = useState(1); // 调试模式

  const [fastCommand, setFastCommand] = useState(0); // 异步命令

  const [contentList, setContentList] = useState([]);

  const [remark, setRemark] = useState(""); // 备注

  // 长、短期任务命令选择--默认短期
  const [shellType, setShellType] = useState(1);

  // 弹框关闭
  const onCancel = () => {
    props.handleShellColse(false);
    init();
  };

  // 初始化
  const init = () => {
    setContentList([]);
    setCommand("");
    setRemark("");
    setTimeOut(120);
    setAutoClose(1);
    setFastCommand(0);
  };

  // 命令输入框
  const handleCommandInput = (e) => {
    const { target } = e;
    setCommand(target.value);
  };

  // 超时时间输入框
  const handleTimeInput = (e) => {
    const { target } = e;
    setTimeOut(target.value);
  };

  // 调试模式
  const handleMode = (bool) => {
    console.log(bool);
    setAutoClose(bool ? 0 : 1);
  };

  // 异步命令
  const handleAsyncCommand = (bool) => {
    setFastCommand(bool ? 1 : 0);
  };

  // 任务命令选择
  const onChangeShell = (e) => {
    setShellType(e.target.value);
  };

  // 执行命令
  const executeCommand = () => {
    if (_isNullorEmpty(command)) {
      return message.warning("命令不能为空！");
    }
    if (_isNullorEmpty(timeOut)) {
      return message.warning("任务超时时间不能为空！");
    }

    if (shellType === 1) {
      getTasklogShortList();
    } else {
      getTasklogLongList();
    }
  };

  // 获取所有命令或某个盒子执行命令列表---短期
  const getTasklogShortList = async () => {
    const params = {
      command,
      timeOut: Number(timeOut),
      autoClose,
      fastCommand,
      remark,
      query: {},
      queryFlag: "0",
      deviceNoList: !_isNullorEmpty(props.list) ? props.list?.join(",") : "all",
    };
    try {
      const { code, data } = await BoxServe.sendBatchRemoteCmd(params);
      if (String(code) === "0") {
        message.success("命令发送成功！");
        const time = dateFormat(new Date(), "YYYY-MM-DD HH:mm:ss");
        setContentList(() => [
          ...contentList,
          {
            id: "时间：",
            resultContent: time,
          },
          {
            id: "命令：",
            resultContent: command,
          },
          {
            id: "当前已发命令批次号：",
            resultContent: data,
          },
        ]);
      } else {
        message.error("错误！");
      }
    } catch (error) {
      message.error(error.message || error.msg);
      console.log(error);
    }
  };

  // 获取所有命令或某个盒子执行命令列表
  const getTasklogLongList = async () => {
    const params = {
      command,
      timeOut: Number(timeOut),
      autoClose,
      fastCommand,
      remark,
      query: {},
      queryFlag: "0",
      deviceNoList: !_isNullorEmpty(props.list) ? props.list?.join(",") : "all",
    };
    try {
      const { code, data } = await BoxServe.sendLongBatchCmd(params);
      if (String(code) === "0") {
        message.success("命令发送成功！");
        const time = dateFormat(new Date(), "YYYY-MM-DD HH:mm:ss");
        setContentList(() => [
          ...contentList,
          {
            id: "时间：",
            resultContent: time,
          },
          {
            id: "命令：",
            resultContent: command,
          },
          {
            id: "当前已发命令批次号：",
            resultContent: data,
          },
        ]);
      } else {
        message.error("错误！");
      }
    } catch (error) {
      message.error(error.message || error.msg);
      console.log(error);
    }
  };

  // 备注
  const handleRemark = (e) => {
    const { target } = e;
    setRemark(target.value);
  };

  return (
    <>
      <div className="shell-wrap">
        <Modal
          title="shell操作"
          open={props.open}
          footer={null}
          width="1200px"
          className="shell"
          onCancel={onCancel}
        >
          <ul>
            <li className="num shell-item">
              <span className="title">盒子编号</span>
              <span className="text">
                {props.list?.map((item, index) => (
                  <span key={item}>
                    {item} {index < props.list.length - 1 ? "、" : ""}
                  </span>
                ))}
                等共{props.list?.length}台
              </span>
            </li>
            <li className="command-wrap shell-item shell-input">
              <span className="title">shell输出</span>
              <div className="command">
                <p>
                  {props.list?.map((item, index) => (
                    <span key={item} className="text">
                      {item} {index < props.list.length - 1 ? "、" : ""}:
                    </span>
                  ))}
                </p>

                {contentList?.map((item, index) => (
                  <p key={index} className="command-p">
                    <span className="command-p__text">
                      {item.deviceNo || item.id}
                    </span>
                    {item.deviceNo ? "-" : ""}
                    {item.resultContent}
                  </p>
                ))}
              </div>
            </li>
            <li className="num shell-item">
              <span className="title">命令</span>
              <Input
                placeholder="请输入命令"
                allowClear
                value={command}
                onChange={handleCommandInput}
              />
            </li>
            <li className="num shell-item">
              <span className="title">任务超时时间(秒)</span>
              <Input
                type="number"
                placeholder="请输入任务超时时间(单位秒,默认120秒)"
                allowClear
                value={timeOut}
                onChange={handleTimeInput}
              />
            </li>
            <li className="num shell-item">
              <span className="title">备注</span>
              <TextArea
                placeholder="请输入备注"
                allowClear
                autoSize={{
                  minRows: 2,
                  maxRows: 5,
                }}
                showCount
                value={remark}
                maxLength={100}
                onChange={handleRemark}
              />
            </li>
            <li className="num shell-item">
              <span className="title">调试模式</span>
              <Switch
                checkedChildren="开"
                unCheckedChildren="关"
                onChange={handleMode}
              />
            </li>
            <li className="num shell-item">
              <span className="title">异步命令</span>
              <Switch
                checkedChildren="开"
                unCheckedChildren="关"
                onChange={handleAsyncCommand}
              />
            </li>
            <li className="num shell-item">
              <span className="title">任务命令</span>
              <Radio.Group onChange={onChangeShell} value={shellType}>
                <Radio value={1}>短期命令</Radio>
                <Radio value={2}>长期命令</Radio>
              </Radio.Group>
            </li>
          </ul>
          <Button
            type="primary"
            shape="round"
            className="shell-btn"
            size="large"
            onClick={executeCommand}
          >
            发布命令
          </Button>
        </Modal>
      </div>
    </>
  );
}
